/**
  * @prop --transition-duration: The transition duration for a single digit. Will be multiplied by the number. Default: 0.2s.
  * @prop --transition-easing: The transition easing. Default: ease.
  */

lg-num-slide {
  --transition-duration: 0.2s;
  --transition-easing: ease;

  display: inline-block;
  font-size: 5rem;

  .column {
    display: inline-block;
    height: 1em;
    line-height: 1;
    overflow: hidden;
  }

  .column .column-inner {
    display: inline-flex;
    flex-direction: column;
    // disable selecting since that
    // would select all digits, not
    // just the visible one.
    user-select: none;

    transform: translateY(calc(var(--selected) * -10%));
  }

  &.reversed .column .column-inner {
    transform: translateY(calc(-90% + var(--selected) * 10%));
  }

  .column.animated .column-inner {
    transition: transform calc(var(--selected) * var(--transition-duration)) var(--transition-easing);
  }
}
